import React, { Component } from 'react';
import { forwardRef } from 'react';
//import Filter from './FilterService'
// Material components

import Portlet from '../Portletcomponents/Portlet';
import PortletHeader from '../Portletcomponents/PortletHeader';
import PortletLabel from '../Portletcomponents/PortletLabel';
import PortletContent from '../Portletcomponents/PortletContent';
import PortletFooter from '../Portletcomponents/PortletFooter';

import Badge from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import compose from 'recompose/compose';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid } from '@material-ui/core';
import 'moment/locale/es'
import Popover from '@material-ui/core/Popover';
import styles from './styles';
//import at_error_codes from '../../../../../../data/at_error_codes'
//import {getDowntimeStepGlobal} from '../../../../../services/getDowntimeStepGlobal'
//import {getObjectiveConfig} from '../../../../../services/getObjectiveConfig'
import {getAvailabilityCustomObjective} from '../../../../../services/getAvailabilityCustomObjective'

import { VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Hidden from '@material-ui/core/Hidden';
import Tooltip from '@material-ui/core/Tooltip'
import { createVerify } from 'crypto';
import update from 'react-addons-update'
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';


import moment from 'moment'
import 'moment/locale/es'
import { object } from 'prop-types';
moment.locale('es')


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

class Incidents extends Component {

    constructor(props) {
        super(props)
    
        //console.log('props',props)
        //console.log(groups)
        this.state = {
            isLoading:true,
            groups:this.props.groups,
            names:this.props.nameGroup,
            dataError:false,
            newList:[],
            maxObjs:this.props.maxObjs,
            contSteps:0,
            listData:[]
        }
    }

    componentDidMount() {
        this.getDataObj();
    }

    getDataObj = () => {
        const {groups, names}=this.state
        let begin=(moment().subtract({'days':1}).format("YYYY-MM-DD"))
        let final=(moment().format("YYYY-MM-DD"))
        //console.log(groups, names)
        Object.keys(groups).map(group=>{
            var dataGroup=(groups[group])
            var orden_grupo=(dataGroup.orden_grupo)
            Object.keys(dataGroup).map(index=>{
                if(isNaN(parseInt(index))===false){
                    var obj=(dataGroup[index])
                    //console.log(obj, begin, final)
                    getAvailabilityCustomObjective(obj.id, 0, begin, final).then(value=>{
                        try {
                            //console.log(value)
                            this.processData(value.Objetivo, orden_grupo) 
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                isLoading: false
                            });
                        }
                    })
                }
            })
        })
    }

    processData=(value, orden)=>{
        //console.log(value)
        const {maxObjs, names}=this.state
        var stepRanges=[]
        Object.keys(value.Paso).map(step=>{
            var step=(value.Paso[step])
            if(step.estado.filter(i=>i.nombre==="downtime").length>0){
                var downListEvent=(step.estado.filter(i=>i.nombre==="downtime"))
                downListEvent.map(i=>{
                    if(moment(i.fecha_hasta)>moment().subtract({'days':1})){
                        stepRanges.push({'inicio':moment(i.fecha_desde).format("YYYY-MM-DD HH:mm:ss"), 'final':moment(i.fecha_hasta).format("YYYY-MM-DD HH:mm:ss")})
                    }
                })
            }
        })
        let hash = []
        stepRanges = stepRanges.filter(o => hash[o.inicio] ? false : hash[o.inicio] = true);
        //console.log('down',stepRanges)
        var objectiveData={'nameObj':value.Objetivo_Nombre, 'idObj':value.Objetivo_Id,"idGroup":orden, 'dataStep':stepRanges}
        this.setState({ 
            newList:[...this.state.newList, objectiveData],
            //isLoading:false
          })
        //console.log(this.state.newList.length, maxObjs)
        if(this.state.newList.length=== maxObjs){
            //console.log(names)
            const listObjs=this.state.newList
            var listData=[]
            names.map(name=>{
                //console.log(name.titulo_grupo, parseInt(name.grupo.substring(5)))
                listObjs.map(obj=>{
                    //console.log(obj)
                    //console.log(parseInt(obj.idGroup)===parseInt(name.grupo.substring(5)))
                    if(parseInt(obj.idGroup)===parseInt(name.grupo.substring(5))){
                        //console.log(obj.nameObj)
                        var statusData=obj.dataStep
                        if(statusData.length!==0){
                            statusData.map(status=>{
                                var duration=(parseFloat((moment(status.final)-moment(status.inicio))/1000))
                                duration=(moment().startOf('day').seconds(duration).format('H:mm:ss'))
                                var hour =parseInt(duration.split(":")[0])
                                var minute=parseInt(duration.split(":")[1])
                                var second=parseInt(duration.split(":")[2])
                                //console.log(hour, minute, second)
                                duration=minute+' minutos' + ' y '+second+' segundos'
                                if(hour!==0){
                                    duration=hour+' horas y '+duration
                                }
                                var statusData='Resuelto'
                                if(status.final>moment().subtract({'minutes':45}).format("YYYY-MM-DD HH:mm:ss")){
                                    statusData='En Curso'
                                }

                               // TODO: TEMP
                               if(statusData!=='En Curso'  && minute >= 5)
                               {
                                listData.push({ servicio: name.titulo_grupo, plataforma: obj.nameObj, fecha: status.inicio, duracion: duration , estado:statusData})
                               }
                               
                               if( (statusData==='En Curso' && minute >= 15) || (statusData==='En Curso' && hour >= 1))
                               {
                                  
                                listData.push({ servicio: name.titulo_grupo, plataforma: obj.nameObj, fecha: status.inicio, duracion: duration , estado:statusData})
                               }
                               
                            })
                        }
                    }
                })
            })
            //console.log(listData)
            listData.sort(function (a, b) {
                return (moment(b.fecha)-moment(a.fecha));
            });
            this.setState({ 
                isLoading:false,
                listData:listData
            })
        }
    }
    

    render() {
        const {isLoading, listData}=this.state
        //console.log(stepsStatus)
        //console.log(element)
        const {classes}=this.props
        if (isLoading===true) {
            return(
                <Grid item lg={6} xl={6}>
                    <Typography
                    className={classes.circular}
                        variant="caption"
                        >
                        <CircularProgress
                        className={classes.circular}
                        variant="indeterminate"
                        size={8}
                        thickness={1}
                        
                        />
                        Cargando Incidentes...
                    </Typography>
                </Grid>
            )
        }else{
            //console.log(listData)
            if(listData.length===0){
                return(
                    <Grid item lg={6} xl={6} style={{textAlign:"center"}} >
                        <Typography variant="h6">No Hay Incidentes Globales</Typography>
                    </Grid>
                )
            }else{
                return(
                    <Grid item lg={6} xl={6} >
                        <Typography 
                            style={{fontSize:"1.5rem", fontWeight:"bold", marginLeft:"25px",paddingBottom:"10px"}}>
                                Incidentes
                            </Typography>
                        {listData.map((ele, i)=>(
                            <Portlet key={i}>
                            
                                <PortletHeader style={{borderBottomStyle:"groove", width:"90%", left:"4%", paddingLeft:"0px"}}   >
                                    <PortletLabel
                                        className={classes.textDate}
                                        title={moment(ele.fecha).format("MMMM D, YYYY HH:mm:ss")}                                
                                    />
                                </PortletHeader>
                                    
                                    <PortletContent >
                                        <Grid 
                                            container
                                            direction="row"
                                            justify="flex-start"
                                            alignItems="center"
                                        >
                                            <Grid item lg={4} xl={4} md={4} className={classes.incidentContent}>
                                                <Typography>Indisponibilidad del Servicio:</Typography>
                                            </Grid>
                                            <Grid item lg={6} xl={6} md={6} className={classes.incidentContent}>
                                                <Typography>{ele.servicio}-{ele.plataforma}</Typography>
                                            </Grid>
                                            
                                            {/*<Grid item lg={4} xl={4} md={4} className={classes.incidentContent}>
                                                <Typography>Fecha:</Typography>
                                            </Grid>
                                            <Grid item lg={6} xl={6} md={6} className={classes.incidentContent}>
                                                <Typography>{ele.fecha}</Typography>
                                            </Grid>*/}
                                            
                                            <Grid item lg={4} xl={4} md={4} className={classes.incidentContent}>
                                                <Typography>Duración:</Typography >
                                            </Grid>
                                            <Grid item lg={6} xl={6} md={6} className={classes.incidentContent}>
                                                <Typography>{ele.duracion}</Typography>
                                            </Grid>
                                            <Grid item lg={4} xl={4} md={4} className={classes.incidentContent}>
                                                <Typography>Estado:</Typography>
                                            </Grid>
                                            <Grid item lg={6} xl={6} md={6} className={classes.incidentContent}>
                                                <Typography>{ele.estado}</Typography>
                                            </Grid>
                                        </Grid>
                                    </PortletContent>
                                <PortletFooter/>
                            
                            
                            </Portlet>
                    ))}
                    </Grid>
                
                )
            }
        }
   
    }
}
export default
    compose(withStyles(styles))(Incidents);